export default __webpack_public_path__ + "static/media/queue_kopihub.b812c2d5.jpg";